import { WizCommand } from '@wizeoo/akm-component-lib';
import { DataLoadObj } from '@wizeoo/akm-compute-lib';
import { BaselineValueLite, BaselineCriteria } from '@wizeoo/akm-message-lib';
import { DataMessage } from '../../manager/baselines/data.message';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/** chargement d'un paquet de baselines */
export class FindDataValuesCommand extends WizCommand<BaselineValueLite[]> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public dlo: DataLoadObj; // la conf d'appel

  /**
   * chargement des baselineValues
   */
  public find(dlo: DataLoadObj, pageIdx: number, pageSize: number): FindDataValuesCommand {
    this.dlo = dlo;
    
    const criteria: BaselineCriteria = new BaselineCriteria();
    criteria.domain = dlo.visionStep.domain;
    criteria.businessUnitCode = dlo.visionStep.businessUnitCode;
    criteria.visionCode = dlo.visionStep.visionCode;
    criteria.chronoCode = dlo.visionStep.chronoCode;
    criteria.scenarioCode = dlo.scenario;
    criteria.level = dlo.visionStep.level;
    criteria.revisionNumber = dlo.revisionNumber;
    criteria.pageIndex = pageIdx;
    criteria.pageSize = pageSize;
    // TODO contrôler GDM
    // criteria.keyLikes = this.model.connectedUser.getVisionRestrictTags();

    this.configureRemote(ExternalAPI.DATA_LITE_VALUES_API, criteria);
    return this;
  }

  public resolve(): void {

    this.dlo.remoteBaselineValues = this.dlo.remoteBaselineValues.concat(this.result);
    // this.model.dataMessage.doMessage(DataMessage.LOAD_REMOTE_RUNNING, this.dlo);
  }

  wizResult() {
    if (!!this.result) {
      this.dlo.loadedRemoteValues += this.result.length;
      this.model.dataMessage.doMessage(DataMessage.LOAD_REMOTE_RUNNING, this.dlo);
      // console.log('dataValue', this.dlo.loadedRemoteValues);
    }
    super.wizResult();
  }

}
